module.exports = __webpack_public_path__ + "img/generate-02.39986a19.png";